import { RouteResponse } from '@/pages/api/trade-history/route';
import { useQuery } from '@tanstack/react-query';

import { ClientNetworkError } from '@/lib/errors/client';

import { ProtocolVersion } from '@/utils/0x/history/types';

import { routes } from '../utils/routes';

interface Params {
  transactionHash: string | undefined;
  tradeId: number | undefined;
  protocolVersion: ProtocolVersion | undefined;
}

const fetcher = async (url: string) => {
  const res = await fetch(url);
  const data = await res.json();
  if (!res.ok) {
    throw new ClientNetworkError(data?.reason ?? 'Unknown error');
  }
  return data as RouteResponse;
};

export const tradeHistoryRouteQueryKey = (transactionHash: string | undefined) =>
  ['trade-history-route', transactionHash] as const;

export function useTradeHistoryRoute({ transactionHash, tradeId, protocolVersion }: Params) {
  return useQuery<RouteResponse | undefined, Error>({
    queryKey: tradeHistoryRouteQueryKey(transactionHash),
    queryFn: () => fetcher(`${routes.api.TRADE_HISTORY_ROUTE}?transactionHash=${transactionHash}`),
    enabled: !!transactionHash && tradeId != null && protocolVersion === 'Settler',
  });
}
